// extracted by mini-css-extract-plugin
export var actionButton = "_s1-0";
export var actionMenuContainer = "_s1-i";
export var bubble = "_s1-2";
export var bubbleActionMenu = "_s1-j";
export var bubbleContext = "_s1-6";
export var bubbleItems = "_s1-7";
export var customer = "_s1-3";
export var divider = "_s1-8";
export var fileList = "_s1-9";
export var hiddenComment = "_s1-o";
export var infoAbove = "_s1-a";
export var internal = "_s1-4";
export var lightActionButton = "_s1-1";
export var link = "_s1-b";
export var merchant = "_s1-5";
export var message = "_s1-c";
export var profilePicture = "_s1-e";
export var quillToolbarContainer = "_s1-f";
export var senderDate = "_s1-g";
export var senderDateCustomer = "_s1-h";
export var senderName = "_s1-d";
export var time = "_s1-k";
export var uploadedImage = "_s1-l";
export var username = "_s1-m";
export var xsmall = "_s1-n";